module.exports = __webpack_public_path__ + "static/media/ic_gimbaltrack_playstore.9c0b8b61.png";